
const version = 'v1.0.4.20260605_01';

const evnName = 'official';
// const evnName = 'test';

export default {
    // 请求基础地址
    requestBaseUrl: evnName === 'official' ? 'https://cert.ckeword.org.cn' : 'https://test.ckeword.org.cn',
    // 资源服务器地址
    resourceBaseUrl: evnName === 'official' ? 'https://resource.ckeword.org.cn' : 'https://test-resource.ckeword.org.cn',
}
